import { render } from "./SocialStrategy.vue?vue&type=template&id=486badef&scoped=true"
import script from "./SocialStrategy.vue?vue&type=script&lang=js"
export * from "./SocialStrategy.vue?vue&type=script&lang=js"

import "./SocialStrategy.vue?vue&type=style&index=0&id=486badef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-486badef"]])

export default __exports__